export default "__VITE_ASSET__DN10K24A__"